<template>
	<div id="register">
		<form-user
			v-on:save-user = "saveUser"
			v-bind:isLoading = "isLoading"
			v-bind:user = "userRec"
			crud = "add"
			title = "Register"
			icon = "fa-user-plus"
		>
		</form-user>
	</div>
</template>
<script>
import FormUser from '@/components/FormUser.vue'
export default {
	components: { FormUser },
	data() {
		return {
			isLoading: false,
			userRec: {
			}
		}
	},
	methods: {
		async saveUser(data){
			this.isLoading = true

			try {
				await this.$store.dispatch('addUser',data)
			//	this.$router.replace('/received')
			}
			catch(err) {
				alert(err)
			} 
			finally {
				this.isLoading = false
			}
		}
	}
}
</script>
<style scoped>
#register  {
	display: grid;
	height: 100vh;
	place-items: center;
}

	#register form {
		width: 330px;
	}
</style>